import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>Pryce Technologies Pte Ltd, All rights reserved.</p>
    </footer>
  );
};

export default Footer;

